import { render, staticRenderFns } from "./permission-config.vue?vue&type=template&id=08f2538f&scoped=true&"
import script from "./permission-config.vue?vue&type=script&lang=ts&"
export * from "./permission-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2538f",
  null
  
)

export default component.exports